import config from '@config';
import Clarity from '@microsoft/clarity';

class ClarityUtil {
    isEnabled() {
        return Boolean(config.clarityProjectId);
    }

    init() {
        if (!this.isEnabled()) return;

        Clarity.init(config.clarityProjectId);
    }

    identify({ customerId, customSessionId = '', customPageId = '', friendlyName = '' }) {
        if (!this.isEnabled()) return;

        Clarity.identify(customerId.toString(), customSessionId, customPageId, friendlyName);
    }

    setTag({ key, value }) {
        if (!this.isEnabled()) return;

        Clarity.setTag(key, value);
    }
}
export const clarityUtil = new ClarityUtil();
